import { render, staticRenderFns } from "./TestWidgetWithCircle.vue?vue&type=template&id=6d42df54&"
import script from "./TestWidgetWithCircle.vue?vue&type=script&lang=js&"
export * from "./TestWidgetWithCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports